<template>
  <div id="upload-pictures">
    <!-- title -->
    <div class="title">
      <div>{{num}}</div>
      <div>{{title}}</div>
    </div>
    <!-- 上传区域 -->
    <div class="upload-box">
      <van-uploader
          v-model="fileList"
          :max-count="1"
          :preview-full-image="false"
          :after-read="upload"
      />
    </div>
    <!-- 上传进度 -->
<!--    <div class="show-uploading" v-if="percent!=null&&percent!=100">上传中</div>-->
        <div class="percent" v-if="percent!=null&&percent!=100&&!isUploadDefeat">
          <van-progress
              :percentage="percent"
              stroke-width="2px"
          />
        </div>
    <!-- 错误显示区 -->
    <div class="show-error">
      <p v-if="isUploadDefeat">上传失败,请重新上传</p>
      <p>{{errorMessage}}</p>
    </div>

  </div>
</template>

<script>
  import * as qiniu from 'qiniu-js';
  import {getQiniuToken} from '@/apis/common.js'

  export default {
    name: "uploadPictures",
    props:{
      num:{type: String, default: '#'}, // 序号
      title:{type: String, default: '标题'}, // 标题
      errorMessage:{type: String} // 错误消息
    },
    data() {
      return {
        fileList: [], // 文件列表
        subscription: null, // 七牛云文件上传实例
        percent: null, // 进度
        isUploadDefeat: false, // 是否上传失败
      }
    },
    methods:{
      // 上传到七牛云
      upload(f) {
        let self = this;
        let baseUrl; // 文件网址
        let file = f.file; // 文件
        let key = new Date().getTime(); // 文件名
        let token; // 七牛云token
        let putExtra = {
          fname: file.name,
          params: {},
        }
        let config = {
          useCdnDomain: true,
        }
        let observable;

        // 监听
        let observer = {
          next(res) {
            console.log(res.total.percent);
            self.percent = Math.floor(res.total.percent);
          },
          error(err) {
            console.log(err);
            self.isUploadDefeat = true;
          },
          complete(res) {
            baseUrl = baseUrl+'/'+key
            self.$emit('update:fileUrl', baseUrl);
          }
        };

        // 获取七牛云token
        getQiniuToken().then(res => {
          baseUrl = res.data.domain;
          token = res.data.token;
          observable = qiniu.upload(file, key, token, putExtra, config);
          this.isUploadDefeat = false;
          this.subscription = observable.subscribe(observer);
        }).catch(err => {
          this.$toast('获取七牛云token失败');
        })
      },
    },
    watch:{
      fileList() {
        if (this.fileList.length === 0) {
          this.subscription.unsubscribe();
          this.$emit('update:file', null);
          this.$emit('update:fileUrl', null);
        } else {
          this.$emit('update:file', this.fileList[0].file);
        }
      }
    }
  }
</script>

<style scoped>
  #upload-pictures{
    background: white;
  }
  .title{
    padding: 0 4vw;
    display: flex;
    align-items: center;
    font-size: 3.733vw;
    color: #606266;
  }
  .title>div:first-child{
    width: 6.133vw;
    height: 6.133vw;
    background-color: #f5f7fa;
    box-sizing: border-box;
    border: solid 0.267vw #edeff2;
    border-radius: 50%;

    display: flex;
    justify-content: center;
    align-items: center;
  }
  .title>div:last-child{
    margin-left: 2.8vw;
  }
  .upload-box{
    display: flex;
    justify-content: center;
  }
  .upload-area{
    margin-top: 4vw;
    width: 66.667vw;
    height: 42.4vw;
    background-color: #f5f7fa;
    border-radius: 2.133vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .upload-area>img{
    width: 16vw;
    height: 16vw;
  }
  .upload-box{margin-top: 3.5vw}
  .show-error{
    display: flex;
    justify-content: center;
    color: #F0283F;
    font-size: 3.5vw;
  }
  .show-uploading{
    display: flex;
    justify-content: center;
    color: #a1a1a1;
    font-size: 3vw;
  }
  .percent{
    width: 60vw;
    margin: 0 auto;
  }

  .upload-box>>>.van-uploader__upload{
    width: 66.667vw;
    height: 42.4vw;
    background-color: #f5f7fa;
    border-radius: 2.133vw;
  }
  .upload-box>>>.van-uploader__preview-image{
    width: 66.667vw;
    height: 42.4vw;
  }
</style>
